import React from 'react';
import GridComponent from '../grid/GridComponent/GridComponent';
import T, { t } from '../../common/components/T';
import Display from '../../common/components/Display';
import Skeleton from '../plug/Skeleton/Skeleton';

export const transformSearchUserData = (dataUser, adminPage) => {
    // convert data for SEARCH window format
    const group = ['username', 'rang', 'contacts'];

    if (dataUser) {
        const newData = [];
        let accum = {};
        Object.keys(dataUser?.data).map((idx) => {
            group.map((item, key) => {
                {
                    Object.keys(dataUser.data[idx]).map((alias) => {
                        if (group[key] === 'contacts' && !dataUser.data[idx].contacts) {
                            accum.contacts = {
                                phone: dataUser.data[idx].phone,
                                email: dataUser.data[idx].email,
                                viber: dataUser.data[idx].viber,
                                telegram: dataUser.data[idx].telegram,
                                whatsapp: dataUser.data[idx].whatsapp,
                                facebook: dataUser.data[idx].facebook,
                                instagram: dataUser.data[idx].instagram,
                                twitter: dataUser.data[idx].twitter
                            };
                        } else if (group[key] === 'usernameFIO') {
                            accum.usernameFIO = dataUser.data[idx].full_name || <Display type='fio' data={dataUser.data[idx]} />;
                        } else if (group[key] === 'rang') {
                            accum.rang = dataUser.data[idx]?.marketing_profile?.rank || dataUser.data[idx]?.rank;
                        } else if (group[key] === 'username') {
                            accum.username = adminPage
                                ? {
                                      username: dataUser.data[idx]?.username,
                                      first_name: dataUser.data[idx]?.first_name,
                                      last_name: dataUser.data[idx]?.last_name,
                                      id: dataUser.data[idx]?.id,
                                      full_name: dataUser?.data[idx]?.full_name
                                  }
                                : {
                                      username: dataUser.data[idx]?.username,
                                      full_name: dataUser.data[idx]?.full_name,
                                      image: dataUser.data[idx]?.image,
                                      id: dataUser.data[idx]?.id
                                  };
                        } else if (group[key] === alias) {
                            accum[`${alias}`] = dataUser.data[idx][`${alias}`];
                        }
                    });
                }
            });
            Object.keys(dataUser.data[idx]).forEach((item) => {
                if (accum[item] === undefined) {
                    accum[item] = dataUser.data[idx][item];
                }
            });
            newData[idx] = accum;
            accum = {};
        });
        const accumReturn = {
            ...dataUser,
            data: newData
        };
        return accumReturn;
    }
    return false;
};
export const getUserTable = (userTableData, screenWidth, gridHandlers, gridConfig, thead, transformSearchData, translates) => {
    const stylesTableWrapper = {
        table: screenWidth ? {} : { minWidth: '686px' }
    };
    const dataThead = thead || {
        data: [
            {
                title: t('SearchWindow-Login', 'Логин', 'widget', translates, 'searchWindow'),
                type: 'login',
                name: 'username'
            },
            {
                title: t('SearchWindow-FIO', 'ФИО', 'widget', translates, 'searchWindow'),
                type: 'text',
                name: 'usernameFIO',
                align: 'left'
            },
            {
                name: 'contacts',
                title: t('SearchWindow-Contacts', 'Контакты', 'widget', translates, 'searchWindow'),
                type: 'contacts',
                align: 'left'
            }
        ]
    };

    const RenderData = () => {
        return (
            <div
                style={{
                    paddingBottom: '32px',
                    overflow: 'hidden'
                }}
            >
                {!!userTableData?.data?.length ? (
                    <GridComponent
                        fullScreen={true}
                        sticky={true}
                        viewThead={dataThead}
                        viewData={userTableData}
                        gridName='userSearch'
                        convertData={transformSearchData || transformSearchUserData}
                        handlers={gridHandlers}
                        variant={2}
                        gridStyles={{
                            ...(gridConfig || {}),
                            tableWrapper: stylesTableWrapper,
                            td: {
                                usernameFIO: {
                                    p: {
                                        maxWidth: ' 400px',
                                        whiteSpace: ' break-spaces'
                                    }
                                },
                                ...(gridConfig?.td || {})
                            }
                        }}
                    />
                ) : (
                    <div
                        style={
                            screenWidth
                                ? {
                                      textAlign: 'center',
                                      background: 'var(--greyTransparentHalfColor)',
                                      borderRadius: '8px',
                                      padding: '16px'
                                  }
                                : {
                                      background: 'var(--greyTransparentHalfColor)',
                                      borderRadius: '8px',
                                      padding: '16px'
                                  }
                        }
                    >
                        <p>
                            <T textName='gridNoData' defaultStr='Нет данных' page='all' />
                        </p>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Skeleton
            elements={[
                {
                    type: 'table',
                    size: {
                        rows: 10,
                        columns: 4
                    }
                }
            ]}
            Component={RenderData}
            wait={Boolean(userTableData)}
        />
    );
};
